import Hero from '@/pages/home/components/Hero';
import ServicesSection from '@/pages/home/components/ServicesSection';
import ProcessSection from '@/pages/home/components/ProcessSection';
import DifferenceSection from '@/pages/home/components/DifferenceSection';
import FounderSection from '@/pages/home/components/FounderSection';
import ClosingSections from '@/pages/home/components/ClosingSections';
import ChecklistPromo from '@/components/feature/ChecklistPromo';

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesSection />
      <ProcessSection />
      <DifferenceSection />
      <FounderSection />
      <ChecklistPromo variant="home" />
      <ClosingSections />
    </>
  );
}